import React, { useContext } from "react";
import { SectionsContext } from "../../context/SectionsContext";

const TestCard = ({ selected, disabled, test }) => {
  const { setSectionTest } = useContext(SectionsContext);
  return (
    <div
      onClick={() => {
        if (!disabled) setSectionTest(test);
      }}
      style={{ opacity: disabled ? 0.3 : 1 }}
      className={`${
        selected !== null && selected.test_id === test.test_id
          ? "bg-dark text-white"
          : "bg-white text-dark"
      } ${
        !disabled ? "hover-orange" : ""
      } shadow d-flex justify-content-between p-3 align-items-center mb-3 me-2`}
    >
      <i className="fa fa-check"></i>
      <div className="ps-2 ps-lg-0 d-flex">
        <span className="d-lg-flex d-md-flex">Quiz: {test.name}</span>{" "}
      </div>
      <i className="fa fa-chevron-right d-lg-flex"></i>
    </div>
  );
};

export default TestCard;
